import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/StationByThermalCameras/Get`, payload),
    GetActive: (payload) => Repository.post(`/api/StationByThermalCameras/GetActive`, payload),
    GetById: (payload) => Repository.post(`/api/StationByThermalCameras/GetById`, payload),
    Add: (payload) => Repository.post(`/api/StationByThermalCameras/Add`, payload),
    Edit: (payload) => Repository.post(`/api/StationByThermalCameras/Edit`, payload),
    Delete: (payload) => Repository.post(`/api/StationByThermalCameras/Delete`, payload),
    ChangeStatus: (payload) => Repository.post(`/api/StationByThermalCameras/ChangeStatus`, payload),
}
